//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQDataTable from "@/components/Generics/AQDataTable/AQDataTable.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import {
    TABLE_SELECTION, TABLE_SEPARATOR, TABLE_CONFIG, TABLE_COLUMNS_DATA, TABLE_COLUMNS_DATA_SECOND, TABLE_CONFIG2
} from "./dataTable.const";

export default {
    name: "ViewAQDataTable",
    components: {
        AQDropdown,
        AQDataTable,
        AQInput,
        AQButton,
        AQTooltip,
        AQBadge
    },
    data() {
        return {
            tableColumns: TABLE_CONFIG,
            tableColumns2: TABLE_CONFIG2,
            tableData: TABLE_COLUMNS_DATA,
            tableData2: TABLE_COLUMNS_DATA,
            selectedRowOnHover: null,
            selectedCell: null,
            tableTotalPages: 2,
            table2TotalPages: 2,
            tableDefaultSelectionList: [],
            tableInitialSort: { descending: true, sortBy: "col3", columns: [] },
            resetCurrentPage: false,
            loadingTable1: false,
            loadingTable2: false,
            propsSelection: {
                selection: "",
                separator: "",
                hideHeader: false,
                hideBottom: false,
                showTableTitle: true,
                mobileView: false,
                addExtraTopRow: false,
                addExtraBottomRow: false,
                topBeforeHeader: false,
                bottomAfterBody: false,
                showSettings: false,
                reorderColumns: false,
                noData: false,
                loading: false,
                rowColorSeparator: true
            }

        };
    },
    computed: {
        getTableProps() {
            return {
                atId: "exemple-table1",
                settingsTitle: "Columns",
                columns: this.tableColumns,
                defaultColumns: this.tableColumns,
                tableData: this.propsSelection.noData ? [] : this.tableData,
                totalPages: this.tableTotalPages,
                selection: this.getDataValue(this.propsSelection.selection),
                hideBottom: this.propsSelection.hideBottom,
                hideHeader: this.propsSelection.hideHeader,
                selectTableRows: this.tableDefaultSelectionList,
                resetCurrentPage: this.resetCurrentPage,
                separator: this.getDataValue(this.propsSelection.separator),
                grid: this.propsSelection.mobileView,
                title: "Test",
                showSettings: this.propsSelection.showSettings,
                reorderColumns: this.propsSelection.reorderColumns,
                loading: this.propsSelection.loading || this.loadingTable1,
                rowColorSeparator: this.propsSelection.rowColorSeparator
            };
        },
        getTableProps1() {
            return {
                atId: "exemple-table1",
                columns: this.tableColumns,
                defaultColumns: this.tableColumns,
                tableData: this.propsSelection.noData ? [] : this.tableData,
                hideBottom: true,
                styledTable: true,
                rowColorSeparator: true,
                removeTableBorder: true
            };
        },
        getTable2Props() {
            return {
                atId: "exemple-table1",
                settingsTitle: "Columns",
                columns: this.tableColumns2,
                defaultColumns: this.tableColumns2,
                tableData: this.propsSelection.noData ? [] : this.tableData2,
                totalPages: this.table2TotalPages,
                selection: this.getDataValue(this.propsSelection.selection),
                hideBottom: this.propsSelection.hideBottom,
                hideHeader: this.propsSelection.hideHeader,
                selectTableRows: this.tableDefaultSelectionList,
                resetCurrentPage: this.resetCurrentPage,
                separator: this.getDataValue(this.propsSelection.separator),
                grid: this.propsSelection.mobileView,
                title: this.propsSelection.showTableTitle ? "Test" : "",
                showSettings: this.propsSelection.showSettings,
                loading: this.loadingTable2,
                noDataDefaultTableHeight: "100%"
            };
        },
        getSelectionProps() {
            return {
                label: "Table Selection",
                options: TABLE_SELECTION,
                defaultValue: "none"
            };
        },
        getSeparatorProps() {
            return {
                label: "Table Separator",
                options: TABLE_SEPARATOR,
                defaultValue: "horizontal"
            };
        }
    },
    methods: {
        deleteRow() {

        },
        orderColumnsChanged(data) {
            this.tableColumns = data;
        },
        orderColumnsChanged2(data) {
            this.tableColumns2 = data;
        },
        getDataValue(data) {
            return data && data[0] ? data[0].value : "";
        },
        changePagination(data) {
            this.loadingTable1 = true;
            if (data.rowsPerPage > 10) {
                this.resetCurrentPage = true;
                this.tableData = [...TABLE_COLUMNS_DATA, ...TABLE_COLUMNS_DATA_SECOND];
                this.tableTotalPages = 1;
                setTimeout(() => {
                    this.resetCurrentPage = false;
                }, 0);
            } else if (data.page > 1) {
                this.tableData = TABLE_COLUMNS_DATA_SECOND;
                this.tableTotalPages = 2;
            } else {
                this.tableData = TABLE_COLUMNS_DATA;
                this.tableTotalPages = 2;
            }
            setTimeout(() => {
                this.loadingTable1 = false;
            }, 300);
        },
        changePagination2(data) {
            this.loadingTable2 = true;
            if (data.rowsPerPage > 10) {
                this.resetCurrentPage = true;
                this.tableData2 = [...TABLE_COLUMNS_DATA, ...TABLE_COLUMNS_DATA_SECOND];
                this.table2TotalPages = 1;
                setTimeout(() => {
                    this.resetCurrentPage = false;
                }, 0);
            } else if (data.page > 1) {
                this.tableData2 = TABLE_COLUMNS_DATA_SECOND;
                this.table2TotalPages = 2;
            } else {
                this.tableData2 = TABLE_COLUMNS_DATA;
                this.table2TotalPages = 2;
            }
            setTimeout(() => {
                this.loadingTable2 = false;
            }, 300);
        }
    }
};
